import React, { useState } from 'react'
import EmailCode from './EmailCode'
import Username from './Username'
import Passwords from './Passwords'

const ForgotPassword = (): JSX.Element => {
  const [isUsernameCorrect, setIsUsernameCorrect] = useState<boolean | null>(
    null
  )
  const [username, setUsername] = useState<string | null>(null)
  const [isEmailCodeCorrect, setIsEmailCodeCorrect] = useState<boolean | null>(
    null
  )
  const [emailCode, setEmailCode] = useState<string | null>(null)

  return (
    <>
      {isUsernameCorrect === null && (
        <Username
          username={username}
          setUsername={setUsername}
          setIsUsernameCorrect={setIsUsernameCorrect}
        />
      )}
      {username !== null &&
        isUsernameCorrect === true &&
        isEmailCodeCorrect === null && (
          <EmailCode
            username={username}
            code={emailCode}
            setCode={setEmailCode}
            setIsCodeCorrect={setIsEmailCodeCorrect}
          />
      )}
      {username !== null &&
        emailCode !== null &&
        isEmailCodeCorrect === true &&
        isUsernameCorrect === true && (
          <Passwords username={username} emailCode={emailCode} />
      )}
    </>
  )
}

export default ForgotPassword
